import { get, post } from '@/request/http'

// 登录接口
export const login = (params) => post('/api/home/login', params)
//退出接口
export const loginOut = (params) => post('/api/home/logout', params)


//获取指标列表
export const gettargets = (params) => get('/api/home/gettargets', params)




// WEBPACK FOOTER //
// ./src/api/userMG.js